<template>
  <div id="app">
    <GlobalStyle :colorT="color_terciario" />
    <router-view />
  </div>
</template>

<script>
import Dashboard from "./components/Dashboard";
import { createGlobalStyle } from "@egoist/vue-emotion";

const GlobalStyle = createGlobalStyle`
  input[type=text], input[type=password], input[type=email]{
    &:focus {
      border-color: ${(props) => props.colorT};
    }
  }
`;

export default {
  name: "app",
  data() {
    return {
      color_principal: "",
      color_secundario: "",
      color_terciario: "",
    };
  },
  components: {
    GlobalStyle,
  },
  methods: {
    fetchConfiguration() {
      this.axios
        .get("../../apidev/api/config/site")
        .then((response) => {
          let conf = response.data.config;
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;

          let icon = document.querySelector("link[rel~='icon']");
          icon.href = this.replaceURL(conf.url_imagen);

          /* let title = document.querySelector("title");
          // removed console log */
          document.title = conf.app_name;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    replaceURL(path) {
      if (path === null || path.includes("blob")) {
        return path;
      } else {
        return "../apidev/" + path;
      }
    },
  },
  beforeMount() {
    this.fetchConfiguration();
  },
};
</script>

<style>
#app {
  font-family: 'Noto Sans', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.altura-mapa {
  height: calc(100vh - 125px);
}
.altura-contenedor {
  height: inherit;
}
@media (min-width: 1024px) {
  .altura-contenedor {
    height: calc(100vh - 65px);
  }
  .altura-mapa {
    height: calc(100vh - 65px);
  }
}

.mapboxgl-popup-content {
  background: #38b2ac !important;
  color: #fff !important;
  font-family: Lato, Arial, sans-serif !important;
  font-size: 1rem !important;
  padding: 20px !important;
  border-radius: 12px !important;
  word-break: break-all !important;
  width: 245px !important;
}

.mapboxgl-popup-close-button {
  background-color: #e36930 !important;
  border-color: #e36930 !important;
  position: absolute !important;
  right: -65px !important;
  /* top: calc(7%) !important; */
  top: calc(20%) !important;
  border-radius: 25px !important;
  width: 50px !important;
  height: 50px !important;
  font-size: 2em !important;
  font-weight: bold !important;
}

.mapboxgl-popup {
  padding-bottom: 46px;
}

.mapboxgl-marker {
  position: absolute !important;
}

.ql-container.ql-snow {
  max-height: 215px;
  overflow: auto;
}

.page-disabled a {
  cursor: not-allowed !important;
}

/* Green-theme. */
.vuecal__menu,
.vuecal__cell-events-count {
  background-color: #38b2ac !important;
}
.vuecal__menu button {
  border-bottom-color: #fff !important;
  color: #fff !important;
}
.vuecal__menu button.active {
  background-color: rgba(255, 255, 255, 0.15) !important;
}
.vuecal__title-bar {
  background-color: #e4f5ef !important;
}
.vuecal__cell.today,
.vuecal__cell.current {
  background-color: rgba(240, 240, 255, 0.4) !important;
}
.vuecal:not(.vuecal--day-view) .vuecal__cell.selected {
  background-color: rgba(235, 255, 245, 0.4) !important;
}
.vuecal__cell.selected:before {
  border-color: rgba(66, 185, 131, 0.5) !important;
}
.vuecal__event.event {
  background-color: #f6ad55 !important;
  border: 1px solid #dd6b20 !important;
  color: #fff !important;
}

.h-80 {
  height: 20rem;
}

.tui-full-calendar-timegrid-todaymarker {
  display: none !important;
}

.tui-full-calendar-month-week-item
  .tui-full-calendar-today
  .tui-full-calendar-weekday-grid-date-decorator {
  background: #0f4c42 !important;
}

.tui-full-calendar-weekday-schedule-bullet {
  display: none !important;
}

.tui-full-calendar-weekday-schedule.tui-full-calendar-weekday-schedule-time
  .tui-full-calendar-weekday-schedule-title {
  text-align: left;
  color: #ffffff !important;
}

.tui-full-calendar-popup-detail .tui-full-calendar-popup-container {
  text-align: left;
}

.cpicker__box {
  padding-bottom: 10px;
}

.cpicker__footer,
.cpicker__history {
  display: none !important;
}
</style>
